import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { useSendCommandAsync } from '@/_core/cqrs/use';

import { createArchiveActivityCommand } from '../../api/commands/factory/createActivityCardArchiveCommands';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ArchiveActivity extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'ArchiveActivity';

    public constructor(public id: string) {
        super(ArchiveActivity.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ArchiveActivity): Promise<boolean> => {
    useSendCommandAsync(action, {
        createCommand: async () => await createArchiveActivityCommand(action),
    });

    return true;
};

const reducer = (state: StorymapState, action: ArchiveActivity): void => {
    const card = state.activities.find((x) => x.id === action.id);

    state.activities.filter((x) => x.order > card.order).forEach((x) => x.order--);
    state.activities = state.activities.filter((x) => x.id !== card.id);

    state.tasks = state.tasks.filter((x) => x.activityId !== card.id);
    state.subtasks = state.subtasks.filter((x) => x.activityId !== card.id);
};

//@ts-ignore
registerMiddleware(ArchiveActivity.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ArchiveActivity.ACTION_TYPE, reducer);
